import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { MovimentacaoService } from 'src/app/service/movimentacai.service';
import { formatarDataApi } from 'src/app/util/date-format.util';
import { aplicarFiltrosConsulta, isFiltroIdNumerico } from 'src/app/util/consulta/wow-consulta.util';
import { Movimentacao } from './movimentacao';

@Component({
  selector: 'app-movimentacao-consulta',
  templateUrl: './movimentacao-consulta.component.html',
  styleUrls: [
    './movimentacao.component.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class MovimentacaoConsultaComponent {

  ordemColunasTabela = ['id', 'contaOrigemDescricao', 'contaDestinoDescricao', 'valorMovimentacao', 'tipoMovimentacao'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100];
  mensagemErros: String[] = [];
  movimentacoes: Movimentacao[] = [];
  tipoFiltro = 'ID';
  tipoFiltros: string[] = ['ID', 'Período'];
  parametro = '';
  dataInicio = new FormControl(null);
  dataFim = new FormControl(null);
  consultaRealizada = false;

  constructor(
    private movimentacaoService: MovimentacaoService,
    private snackBar: MatSnackBar,
    private router: Router,
  ) { }

  novo() {
    this.router.navigate(['/movimentacao/form']);
  }

  onFiltroChange() {
    this.consultaRealizada = false;
    this.movimentacoes = [];
    this.totalElementos = 0;
    this.pagina = 0;
  }

  validarFiltros(): boolean {
    if (this.tipoFiltro === 'ID') {
      const termo = this.parametro?.trim();
      if (termo && !/^\d+$/.test(termo)) {
        this.snackBar.open('Informe um ID numérico válido.', 'ERRO', { duration: 2500 });
        return false;
      }
      return true;
    }
    if (!this.dataInicio.value || !this.dataFim.value) {
      this.snackBar.open('Informe a data início e fim para consultar.', 'ERRO', { duration: 2500 });
      return false;
    }
    if (this.dataInicio.value.getTime() > this.dataFim.value.getTime()) {
      this.snackBar.open('A data início não pode ser maior que a data fim.', 'ERRO', { duration: 2500 });
      return false;
    }
    return true;
  }

  consultar(resetPagina = true) {
    if (!this.validarFiltros()) {
      return;
    }
    if (resetPagina) {
      this.pagina = 0;
    }

    if (this.tipoFiltro === 'ID') {
      const idFiltro = isFiltroIdNumerico(this.tipoFiltro, this.parametro);
      const request = idFiltro != null
        ? this.movimentacaoService.list(0, 500)
        : this.movimentacaoService.list(this.pagina, this.tamanho);

      request.subscribe((response) => {
        let lista = response.content ?? [];
        if (idFiltro != null) {
          lista = lista.filter(m => m.id === idFiltro);
        } else if (this.parametro?.trim()) {
          lista = aplicarFiltrosConsulta(lista, this.tipoFiltro, this.parametro, null, { id: m => m.id });
        }
        this.movimentacoes = lista;
        this.totalElementos = idFiltro != null ? lista.length : (response.totalElements ?? lista.length);
        this.pagina = idFiltro != null ? 0 : (response.number ?? this.pagina);
        this.consultaRealizada = true;
        this.mensagemErros = [];
        if (idFiltro != null && lista.length === 0) {
          this.snackBar.open('Movimentação não encontrada.', 'ERRO', { duration: 2500 });
        }
      }, err => {
        this.mensagemErros = [err.error?.message ?? 'Erro ao consultar movimentações.'];
        this.snackBar.open(String(this.mensagemErros[0]), 'ERRO', { duration: 3000 });
      });
      return;
    }

    const inicio = formatarDataApi(this.dataInicio.value);
    const fim = formatarDataApi(this.dataFim.value);

    this.movimentacaoService.findSale(this.pagina, this.tamanho, inicio, fim).subscribe((response) => {
      this.movimentacoes = response.content;
      this.totalElementos = response.totalElements;
      this.pagina = response.number;
      this.consultaRealizada = true;
      this.mensagemErros = [];
    }, err => {
      this.mensagemErros = [err.error?.message ?? 'Erro ao consultar movimentações.'];
      this.snackBar.open(String(this.mensagemErros[0]), 'ERRO', { duration: 3000 });
    });
  }

  paginar(event: PageEvent) {
    if (!this.consultaRealizada) {
      return;
    }
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.consultar(false);
  }
}
